import { getMemberBalances, getPrimaryMemberBalance } from '@vista-digital/occ-domain'
import type { LogFunctions } from '@/content/services/logger'
import type { RewardPropsApi } from '../models/reward.models'

export const isRewardRedeemable = (reward: RewardPropsApi, logger: LogFunctions) => {
    logger.trace('Checking if reward is redeemable', { reward })

    if (reward.rewardType === 'Instant Reward') {
        logger.debug(`${reward.title} is an instant reward, so it is always redeemable.`)
        return true
    }

    if (!reward.rewardCost) {
        logger.warn(
            `The reward type of ${reward.title} is expected to have a reward cost, but none was provided. Reward will appear as redeemable!`
        )
        return true
    }

    const balance = reward.burnBalanceTypeId
        ? getMemberBalances()?.find(b => b.balanceTypeId === reward.burnBalanceTypeId)
        : getPrimaryMemberBalance()

    logger.trace('Got member balance for reward', { balance, rewardBurnBalanceTypeId: reward.burnBalanceTypeId })

    if (!balance) {
        logger.warn('No member balance found for reward. Reward will not appear as redeemable!')
        return false
    }

    const isRedeemable = reward.rewardCost <= balance.availableUnits

    logger.debug(
        `${reward.title} costs ${reward.rewardCost}, member balance is ${balance.availableUnits}. The reward ${isRedeemable ? 'is' : 'is not'} redeemable.`
    )

    return isRedeemable
}
